import { render, staticRenderFns } from "./ComponentDataTableRow.vue?vue&type=template&id=6568c70c&"
import script from "./ComponentDataTableRow.vue?vue&type=script&lang=js&"
export * from "./ComponentDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports